var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500092,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2540",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500092,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.500092,
    width: 22,
    height: 16,
    fill: "#FF2936"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500092 16H8.88104V0H0.500092V16Z",
    fill: "#128415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88104 10.8C10.4177 10.8 11.6429 9.53502 11.6429 8C11.6429 6.46498 10.4177 5.2 8.88104 5.2C7.3444 5.2 6.11913 6.46498 6.11913 8C6.11913 9.53502 7.3444 10.8 8.88104 10.8Z",
    stroke: "#FAF94F",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83344 6.73333C7.83344 6.54924 7.98267 6.4 8.16677 6.4H9.59534C9.77944 6.4 9.92867 6.54924 9.92867 6.73333V8.55238C9.92867 9.13096 9.45964 9.6 8.88105 9.6V9.6C8.30247 9.6 7.83344 9.13096 7.83344 8.55238V6.73333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88105 8.53333C9.17034 8.53333 9.40486 7.76122 9.40486 7.46667C9.40486 7.17211 9.17034 6.93333 8.88105 6.93333C8.59176 6.93333 8.35724 7.17211 8.35724 7.46667C8.35724 7.76122 8.59176 8.53333 8.88105 8.53333Z",
    fill: "#1D50B5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.593e8a7bd80e7c3becc30b5e17e8d881.svg";
export { ForwardRef as ReactComponent };